import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

import { ContentSquareIcon } from './ContentsquareReplayIcon';

// RAN-290: This component will be removed in the cleanup for this ticket
const StyledCsButton = styled.a`
  // baseStyles
  display: inline-flex;
  align-items: center;
  border: 0;
  outline: none;
  ${tokens.transition('all')};
  cursor: pointer;
  white-space: nowrap;
  border-radius: ${tokens.radius.m};
  ${tokens.text('subtitle2')};
  padding: 0 ${tokens.spacer.x2};
  gap: ${tokens.spacer.x1};

  text-decoration: none;
  height: 40px;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }

  // Primary kind styles
  color: ${tokens.color.text_default_inverse};
  background-color: ${tokens.color.primary_cta};
  &:hover,
  &:focus,
  &:active {
    color: ${tokens.color.text_default_inverse};
  }
  &:hover,
  &:active {
    background-color: ${tokens.color.primary_cta_alt};
  }
`;

interface ContentsquareReplayButtonProps {
  url: string;
  onClick: () => void;
}

export const ContentsquareReplayButton = ({
  url,
  onClick,
}: ContentsquareReplayButtonProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys.responses-list.recording' });
  return (
    <StyledCsButton target="_blank" href={url} aria-label={t('go-to-replay')} onClick={onClick}>
      <ContentSquareIcon color={tokens.color.white} />
      <span>{t('go-to-replay')}</span>
    </StyledCsButton>
  );
};
